import { Link } from "react-router-dom";
import { imgSrc } from "@/lib/api";
import { SiteHeader, SiteFooter } from "@/components/Layout";

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}

export default function PostView({ post, preview = false }) {
  return (
    <div className="dd-root" data-testid={preview ? "preview-page" : "post-page"}>
      {preview ? (
        <div className="dd-preview-banner" data-testid="preview-banner">
          Preview &mdash; status: <strong>{post.status}</strong>. Only you can see this link.
        </div>
      ) : null}
      <SiteHeader />
      <main>
        <div className="dd-wrap">
          <article className="dd-single">
            <div className="dd-meta">{formatDate(post.publish_date)}</div>
            <h1 className="dd-title" data-testid="post-title">{post.title}</h1>
            {post.featured_image ? (
              <div className="dd-hero"><img src={imgSrc(post.featured_image)} alt={post.title} /></div>
            ) : null}
            <div className="dd-content" data-testid="post-content" dangerouslySetInnerHTML={{ __html: post.body_html || "" }} />
            <Link to="/" className="dd-back" data-testid="post-back-home">&larr; Back home</Link>
          </article>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
